// business.service.ts
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class BusinessOwnerService {
  private apiUrl = eps.company.businessOwnerApi

  constructor(private http: HttpClient) {}

  // getBusinesses(): Observable<any> {
  //   return this.http.get<any>(this.apiUrl)
  // }

  getAllBusinessOwners(params: string | null, page?: number, limit?: number): Observable<any> {
    // const url = params
    //   ? `${this.apiUrl}/all?${params}&page=${page}&limit=${limit}`
    //   : `${this.apiUrl}?page=${page}&limit=${limit}`
    const url = `${this.apiUrl}/all?${params}&page=${page}&limit=${limit}`
    return this.http.get<any>(url)
    // return this.http.get<any>(`${this.apiUrl}/all`)
  }
}
